export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** An ISO 8601-encoded date */
  ISO8601Date: { input: string; output: string; }
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: { input: string; output: string; }
};

/** An API user represents a user of the Admin */
export type ApiUser = {
  __typename?: 'ApiUser';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** An Active Storage attachment. */
export type Attachment = {
  __typename?: 'Attachment';
  attached: Scalars['Boolean']['output'];
  contentType?: Maybe<Scalars['String']['output']>;
  downloadLink?: Maybe<Scalars['String']['output']>;
  fileSize?: Maybe<Scalars['Int']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
};

/** Enumeration for haircut back styles. */
export enum BackStyle {
  /** Not defined */
  NotDefined = 'NOT_DEFINED',
  /** Rounded (Abgerundet) */
  Rounded = 'ROUNDED',
  /** Straight (Gerade) */
  Straight = 'STRAIGHT'
}

/** A booking made by a customer for a service at a store. */
export type Booking = {
  __typename?: 'Booking';
  bookingCode: Scalars['String']['output'];
  coupon?: Maybe<Coupon>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  customName?: Maybe<Scalars['String']['output']>;
  customer: Customer;
  daysSinceLastBooking: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  manual: Scalars['Boolean']['output'];
  paymentTransaction?: Maybe<PaymentTransaction>;
  review?: Maybe<Review>;
  service: Service;
  serviceExecution?: Maybe<ServiceExecution>;
  store: Store;
  uid: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  waitingTime: Scalars['Int']['output'];
};

/** Input type for booking transaction data. */
export type BookingTransactionDataInput = {
  /** The code of the coupon applied to the transaction, if any. */
  couponCode?: InputMaybe<Scalars['String']['input']>;
  /** The name of the customer making the transaction. */
  customerName: Scalars['String']['input'];
  /** Indicates if the customer is a kid. */
  kidCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates if the transaction was created by a manual booking. */
  manual?: InputMaybe<Scalars['Boolean']['input']>;
  /** The phone number of the customer. */
  phoneNumber: Scalars['String']['input'];
  /** Indicates if the booking is silent. */
  silentBooking?: InputMaybe<Scalars['Boolean']['input']>;
  /** The slug of the store associated with the booking. */
  storeSlug: Scalars['String']['input'];
};

/** A break time taken by an employee during their working hours. */
export type BreakTime = {
  __typename?: 'BreakTime';
  createdAt: Scalars['ISO8601DateTime']['output'];
  duration: Scalars['Int']['output'];
  employee: Employee;
  endedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  store: Store;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The type of operation being performed in a broadcast event. */
export enum BroadcastOperation {
  /** A new record is being added */
  Add = 'ADD',
  /** A record is being removed */
  Remove = 'REMOVE',
  /** A record is being updated */
  Update = 'UPDATE'
}

/** Autogenerated input type of CallNextCustomer */
export type CallNextCustomerInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the stylist calling the next customer. */
  stylistId: Scalars['ID']['input'];
};

/** Autogenerated return type of CallNextCustomer. */
export type CallNextCustomerPayload = {
  __typename?: 'CallNextCustomerPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<RecordError>;
  serviceExecution?: Maybe<ServiceExecution>;
  stylist?: Maybe<Employee>;
};

/** Autogenerated input type of CancelPreBooking */
export type CancelPreBookingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the pre-booking to cancel. */
  preBookingId: Scalars['ID']['input'];
};

/** Autogenerated return type of CancelPreBooking. */
export type CancelPreBookingPayload = {
  __typename?: 'CancelPreBookingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<RecordError>;
  preBooking?: Maybe<PreBooking>;
};

/** A check-in record for a stylist at a store. */
export type CheckIn = {
  __typename?: 'CheckIn';
  endedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  startedAt: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated input type of CheckIn */
export type CheckInInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the stylist to check in. */
  stylistId: Scalars['ID']['input'];
};

/** Autogenerated return type of CheckIn. */
export type CheckInPayload = {
  __typename?: 'CheckInPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<RecordError>;
  stylist?: Maybe<Employee>;
};

/** Autogenerated input type of CheckOut */
export type CheckOutInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the stylist to check out. */
  stylistId: Scalars['ID']['input'];
};

/** Autogenerated return type of CheckOut. */
export type CheckOutPayload = {
  __typename?: 'CheckOutPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<RecordError>;
  stylist?: Maybe<Employee>;
};

/** The type of checkout for bookings in a salon. */
export enum CheckoutEnum {
  /** Both */
  Both = 'BOTH',
  /** Instant */
  Instant = 'INSTANT',
  /** Scheduled */
  Scheduled = 'SCHEDULED'
}

/** Autogenerated input type of ConvertPreBooking */
export type ConvertPreBookingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the pre-booking to convert. */
  preBookingId: Scalars['ID']['input'];
};

/** Autogenerated return type of ConvertPreBooking. */
export type ConvertPreBookingPayload = {
  __typename?: 'ConvertPreBookingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<RecordError>;
  preBooking?: Maybe<PreBooking>;
};

/** A discount coupon that can be applied to bookings. */
export type Coupon = {
  __typename?: 'Coupon';
  bookingsCount: Scalars['Int']['output'];
  code: Scalars['String']['output'];
  customer?: Maybe<Customer>;
  expired: Scalars['Boolean']['output'];
  expiresAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  maxUses: Scalars['Int']['output'];
  price: Scalars['Int']['output'];
  type: Scalars['String']['output'];
  usesLeft: Scalars['Int']['output'];
};

/** Autogenerated input type of CreateBooking */
export type CreateBookingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the payment transaction to create a booking for. */
  transactionId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateBooking. */
export type CreateBookingPayload = {
  __typename?: 'CreateBookingPayload';
  booking?: Maybe<Booking>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<RecordError>;
};

/** Autogenerated input type of CreateBookingTransaction */
export type CreateBookingTransactionInput = {
  /** The amount for the transaction. */
  amount: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Additional data for the booking transaction. */
  data: BookingTransactionDataInput;
  /** The payment method to be used for the transaction. */
  paymentMethod: Scalars['String']['input'];
};

/** Autogenerated return type of CreateBookingTransaction. */
export type CreateBookingTransactionPayload = {
  __typename?: 'CreateBookingTransactionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<RecordError>;
  paymentTransaction?: Maybe<PaymentTransaction>;
};

/** Autogenerated input type of CreateCoupon */
export type CreateCouponInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the customer */
  customerId?: InputMaybe<Scalars['ID']['input']>;
  /** Reason for creating the coupon */
  reason: Scalars['String']['input'];
  /** ID of the stylist */
  stylistId?: InputMaybe<Scalars['ID']['input']>;
  /** Type of the coupon */
  type: Scalars['String']['input'];
};

/** Autogenerated return type of CreateCoupon. */
export type CreateCouponPayload = {
  __typename?: 'CreateCouponPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  coupon?: Maybe<Coupon>;
  errors: Array<RecordError>;
};

/** Autogenerated input type of CreatePassPurchase */
export type CreatePassPurchaseInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the payment transaction to associate with the pass purchase. */
  paymentTransactionId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreatePassPurchase. */
export type CreatePassPurchasePayload = {
  __typename?: 'CreatePassPurchasePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<RecordError>;
  passPurchase?: Maybe<PassPurchase>;
};

/** Autogenerated input type of CreatePassTransaction */
export type CreatePassTransactionInput = {
  /** The amount for the transaction */
  amount: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Additional data for the transaction */
  data: PassPurchaseTransactionDataInput;
  /** The payment method to be used */
  paymentMethod: Scalars['String']['input'];
};

/** Autogenerated return type of CreatePassTransaction. */
export type CreatePassTransactionPayload = {
  __typename?: 'CreatePassTransactionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<RecordError>;
  paymentTransaction?: Maybe<PaymentTransaction>;
};

/** Autogenerated input type of CreatePreBooking */
export type CreatePreBookingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the payment transaction to create the pre-booking from. */
  transactionId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreatePreBooking. */
export type CreatePreBookingPayload = {
  __typename?: 'CreatePreBookingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<RecordError>;
  preBooking?: Maybe<PreBooking>;
};

/** Autogenerated input type of CreatePreBookingTransaction */
export type CreatePreBookingTransactionInput = {
  /** The amount for the transaction. */
  amount: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Additional data for the transaction. */
  data: PreBookingTransactionDataInput;
  /** The payment method to be used. */
  paymentMethod: Scalars['String']['input'];
};

/** Autogenerated return type of CreatePreBookingTransaction. */
export type CreatePreBookingTransactionPayload = {
  __typename?: 'CreatePreBookingTransactionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<RecordError>;
  paymentTransaction?: Maybe<PaymentTransaction>;
};

/** Autogenerated input type of CreateReview */
export type CreateReviewInput = {
  /** The ID of the booking to review. */
  bookingId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The data for the review. */
  data: ReviewInput;
};

/** Autogenerated return type of CreateReview. */
export type CreateReviewPayload = {
  __typename?: 'CreateReviewPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<RecordError>;
  review?: Maybe<Review>;
};

/** A customer who makes bookings at stores. */
export type Customer = {
  __typename?: 'Customer';
  avgReviewScore: Scalars['Float']['output'];
  bookingsCount: Scalars['Int']['output'];
  code: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  invalidPhone: Scalars['Boolean']['output'];
  lastBookingDate?: Maybe<Scalars['ISO8601Date']['output']>;
  name: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  preferences: CustomerPreferences;
  settings?: Maybe<CustomerSettings>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Customer hair preferences. */
export type CustomerPreferences = {
  __typename?: 'CustomerPreferences';
  backStyle?: Maybe<BackStyle>;
  cutEyebrows: Scalars['Boolean']['output'];
  ears?: Maybe<EarStyle>;
  hairLength?: Maybe<HairLength>;
  layers: Scalars['Boolean']['output'];
  lengthSides?: Maybe<Scalars['Int']['output']>;
  lengthTop?: Maybe<Scalars['Int']['output']>;
  neckline?: Maybe<Neckline>;
  notes?: Maybe<Scalars['String']['output']>;
  parting?: Maybe<Parting>;
  submittedPreferences: Scalars['Boolean']['output'];
};

/** Input type for customer hair preferences. */
export type CustomerPreferencesInput = {
  /** Preferred style for the back of the hair. */
  backStyle?: InputMaybe<BackStyle>;
  /** Whether the customer wants their eyebrows cut. */
  cutEyebrows?: InputMaybe<Scalars['Boolean']['input']>;
  /** Preferred style for the ears. */
  ears?: InputMaybe<EarStyle>;
  /** Preferred overall hair length. */
  hairLength?: InputMaybe<HairLength>;
  /** Whether the customer wants layers in their haircut. */
  layers?: InputMaybe<Scalars['Boolean']['input']>;
  /** Preferred length for the sides of the hair. */
  lengthSides?: InputMaybe<Scalars['Int']['input']>;
  /** Preferred length for the top of the hair. */
  lengthTop?: InputMaybe<Scalars['Int']['input']>;
  /** Preferred neckline style. */
  neckline?: InputMaybe<Neckline>;
  /** Additional notes or instructions from the customer. */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Preferred hair parting style. */
  parting?: InputMaybe<Parting>;
  /** Indicates if the customer has submitted preferences. */
  submittedPreferences: Scalars['Boolean']['input'];
};

/** Customer communication settings. */
export type CustomerSettings = {
  __typename?: 'CustomerSettings';
  loyaltyMessages: Scalars['Boolean']['output'];
  personalizedOffers: Scalars['Boolean']['output'];
  serviceMessages: Scalars['Boolean']['output'];
};

/** Input for customer communication settings. */
export type CustomerSettingsInput = {
  /** Indicates if the customer wants to receive loyalty messages. */
  loyaltyMessages: Scalars['Boolean']['input'];
  /** Indicates if the customer wants to receive personalized offers. */
  personalizedOffers: Scalars['Boolean']['input'];
  /** Indicates if the customer wants to receive service messages. */
  serviceMessages: Scalars['Boolean']['input'];
};

/** Ear style options for customer hair preferences. */
export enum EarStyle {
  /** Covered (bedeckt) */
  Covered = 'COVERED',
  /** Not defined */
  NotDefined = 'NOT_DEFINED',
  /** Uncovered (frei) */
  Uncovered = 'UNCOVERED'
}

/** An employee working at a store. */
export type Employee = {
  __typename?: 'Employee';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  currentBreak?: Maybe<BreakTime>;
  currentCheckIn?: Maybe<CheckIn>;
  currentServiceExecution?: Maybe<ServiceExecution>;
  id: Scalars['ID']['output'];
  lastActionStore?: Maybe<Store>;
  name: Scalars['String']['output'];
  serviceExecutionsCount: Scalars['Int']['output'];
  state: StylistState;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for Employee. */
export type EmployeeConnection = {
  __typename?: 'EmployeeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EmployeeEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Employee>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type EmployeeEdge = {
  __typename?: 'EmployeeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Employee>;
};

/** Autogenerated input type of EndBreak */
export type EndBreakInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the stylist ending their break time. */
  stylistId: Scalars['ID']['input'];
};

/** Autogenerated return type of EndBreak. */
export type EndBreakPayload = {
  __typename?: 'EndBreakPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<RecordError>;
  stylist?: Maybe<Employee>;
};

/** Autogenerated input type of EndService */
export type EndServiceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the service execution to end. */
  serviceExecutionId: Scalars['ID']['input'];
};

/** Autogenerated return type of EndService. */
export type EndServicePayload = {
  __typename?: 'EndServicePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<RecordError>;
  serviceExecution?: Maybe<ServiceExecution>;
  stylist?: Maybe<Employee>;
};

/** Units for expiration timeframes. */
export enum ExpireUnit {
  /** Days */
  Days = 'DAYS',
  /** Months */
  Months = 'MONTHS'
}

/** The length of the hair. */
export enum HairLength {
  /** Long (Lang) */
  Long = 'LONG',
  /** Not defined */
  NotDefined = 'NOT_DEFINED',
  /** Short (Kurz) */
  Short = 'SHORT'
}

/** Autogenerated input type of HoldService */
export type HoldServiceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the service execution to be placed on hold. */
  serviceExecutionId: Scalars['ID']['input'];
};

/** Autogenerated return type of HoldService. */
export type HoldServicePayload = {
  __typename?: 'HoldServicePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<RecordError>;
  serviceExecution?: Maybe<ServiceExecution>;
};

/** The mutation root of this schema */
export type Mutation = {
  __typename?: 'Mutation';
  /** Calls the next customer in line for the specified stylist. */
  callNextCustomer?: Maybe<CallNextCustomerPayload>;
  /** Cancel a pre-booking made by a customer. */
  cancelPreBooking?: Maybe<CancelPreBookingPayload>;
  /** Check in a stylist to the current store. */
  checkIn?: Maybe<CheckInPayload>;
  /** Check out a stylist from the current store. */
  checkOut?: Maybe<CheckOutPayload>;
  /** Convert a pre-booking into a confirmed booking. */
  convertPreBooking?: Maybe<ConvertPreBookingPayload>;
  /** Create a booking for a payment transaction. */
  createBooking?: Maybe<CreateBookingPayload>;
  /** Creates a payment transaction for a booking. */
  createBookingTransaction?: Maybe<CreateBookingTransactionPayload>;
  /** Creates a coupon from the stylist dashboard */
  createCoupon?: Maybe<CreateCouponPayload>;
  /** Creates a pass purchase associated with a payment transaction. */
  createPassPurchase?: Maybe<CreatePassPurchasePayload>;
  /** Creates a payment transaction for purchasing a pass. */
  createPassTransaction?: Maybe<CreatePassTransactionPayload>;
  /** Creates a pre-booking from a payment transaction. */
  createPreBooking?: Maybe<CreatePreBookingPayload>;
  /** Creates a pre-booking payment transaction. */
  createPreBookingTransaction?: Maybe<CreatePreBookingTransactionPayload>;
  /** Create a review for a booking. */
  createReview?: Maybe<CreateReviewPayload>;
  /** Ends a stylist's break time. */
  endBreak?: Maybe<EndBreakPayload>;
  /** Ends an ongoing service execution. */
  endService?: Maybe<EndServicePayload>;
  /** Place a service execution on hold. */
  holdService?: Maybe<HoldServicePayload>;
  /** Queues a service execution for processing. */
  queueService?: Maybe<QueueServicePayload>;
  /** Snooze a service execution reminder. */
  snoozeReminder?: Maybe<SnoozeReminderPayload>;
  /** Starts a break time for a stylist. */
  startBreak?: Maybe<StartBreakPayload>;
  /** Starts a service execution for a given service execution ID. */
  startService?: Maybe<StartServicePayload>;
  /** Sign in a store and receive an authentication token. */
  storeSignIn?: Maybe<StoreSignInPayload>;
  /** Update customer haircut preferences. */
  updatePreferences?: Maybe<UpdatePreferencesPayload>;
  /** Update customer communication settings. */
  updateSettings?: Maybe<UpdateSettingsPayload>;
  /** Validates a coupon code for a given phone number. */
  validateCoupon?: Maybe<ValidateCouponPayload>;
  /**
   * Validates a customer phone number.
   * @deprecated This mutation is deprecated. Use ValidatePhoneNumber instead.
   */
  validatePhoneCustomer?: Maybe<ValidatePhoneCustomerPayload>;
  /** Validates a customer phone number. */
  validatePhoneNumber?: Maybe<ValidatePhoneNumberPayload>;
  /** Verifies a stylist's credentials for authentication purposes */
  verifyStylistCredentials?: Maybe<VerifyStylistCredentialsPayload>;
};


/** The mutation root of this schema */
export type MutationCallNextCustomerArgs = {
  input: CallNextCustomerInput;
};


/** The mutation root of this schema */
export type MutationCancelPreBookingArgs = {
  input: CancelPreBookingInput;
};


/** The mutation root of this schema */
export type MutationCheckInArgs = {
  input: CheckInInput;
};


/** The mutation root of this schema */
export type MutationCheckOutArgs = {
  input: CheckOutInput;
};


/** The mutation root of this schema */
export type MutationConvertPreBookingArgs = {
  input: ConvertPreBookingInput;
};


/** The mutation root of this schema */
export type MutationCreateBookingArgs = {
  input: CreateBookingInput;
};


/** The mutation root of this schema */
export type MutationCreateBookingTransactionArgs = {
  input: CreateBookingTransactionInput;
};


/** The mutation root of this schema */
export type MutationCreateCouponArgs = {
  input: CreateCouponInput;
};


/** The mutation root of this schema */
export type MutationCreatePassPurchaseArgs = {
  input: CreatePassPurchaseInput;
};


/** The mutation root of this schema */
export type MutationCreatePassTransactionArgs = {
  input: CreatePassTransactionInput;
};


/** The mutation root of this schema */
export type MutationCreatePreBookingArgs = {
  input: CreatePreBookingInput;
};


/** The mutation root of this schema */
export type MutationCreatePreBookingTransactionArgs = {
  input: CreatePreBookingTransactionInput;
};


/** The mutation root of this schema */
export type MutationCreateReviewArgs = {
  input: CreateReviewInput;
};


/** The mutation root of this schema */
export type MutationEndBreakArgs = {
  input: EndBreakInput;
};


/** The mutation root of this schema */
export type MutationEndServiceArgs = {
  input: EndServiceInput;
};


/** The mutation root of this schema */
export type MutationHoldServiceArgs = {
  input: HoldServiceInput;
};


/** The mutation root of this schema */
export type MutationQueueServiceArgs = {
  input: QueueServiceInput;
};


/** The mutation root of this schema */
export type MutationSnoozeReminderArgs = {
  input: SnoozeReminderInput;
};


/** The mutation root of this schema */
export type MutationStartBreakArgs = {
  input: StartBreakInput;
};


/** The mutation root of this schema */
export type MutationStartServiceArgs = {
  input: StartServiceInput;
};


/** The mutation root of this schema */
export type MutationStoreSignInArgs = {
  input: StoreSignInInput;
};


/** The mutation root of this schema */
export type MutationUpdatePreferencesArgs = {
  input: UpdatePreferencesInput;
};


/** The mutation root of this schema */
export type MutationUpdateSettingsArgs = {
  input: UpdateSettingsInput;
};


/** The mutation root of this schema */
export type MutationValidateCouponArgs = {
  input: ValidateCouponInput;
};


/** The mutation root of this schema */
export type MutationValidatePhoneCustomerArgs = {
  input: ValidatePhoneCustomerInput;
};


/** The mutation root of this schema */
export type MutationValidatePhoneNumberArgs = {
  input: ValidatePhoneNumberInput;
};


/** The mutation root of this schema */
export type MutationVerifyStylistCredentialsArgs = {
  input: VerifyStylistCredentialsInput;
};

/** Enum for neckline styles. */
export enum Neckline {
  /** Not defined */
  NotDefined = 'NOT_DEFINED',
  /** Straight (gerade) */
  Straight = 'STRAIGHT',
  /** Tapered (auslaufend) */
  Tapered = 'TAPERED'
}

/** The reason for overriding a presence. */
export enum OverrideReason {
  /** Generic */
  Generic = 'GENERIC',
  /** Sickness */
  Sickness = 'SICKNESS',
  /** Vacation */
  Vacation = 'VACATION'
}

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** Enumeration for hair parting styles. */
export enum Parting {
  /** Left (links) */
  Left = 'LEFT',
  /** Middle (Mitte) */
  Middle = 'MIDDLE',
  /** Not defined */
  NotDefined = 'NOT_DEFINED',
  /** Right (rechts) */
  Right = 'RIGHT'
}

/** A DRYCUT pass that can be purchased by customers for discounted services. */
export type Pass = {
  __typename?: 'Pass';
  active: Scalars['Boolean']['output'];
  basePrice: Scalars['Int']['output'];
  bookingsPaid: Scalars['Int']['output'];
  customColor: Scalars['String']['output'];
  expireUnit: ExpireUnit;
  id: Scalars['ID']['output'];
  maxUses: Scalars['Int']['output'];
  price: Scalars['Int']['output'];
  purchasesCount: Scalars['Int']['output'];
  specialPromotion: Scalars['Boolean']['output'];
  subtitle?: Maybe<Scalars['String']['output']>;
  timeToExpire: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

/** The connection type for Pass. */
export type PassConnection = {
  __typename?: 'PassConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PassEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Pass>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PassEdge = {
  __typename?: 'PassEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Pass>;
};

/** A purchase of a pass by a customer. */
export type PassPurchase = {
  __typename?: 'PassPurchase';
  coupon?: Maybe<Coupon>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  customer: Customer;
  id: Scalars['ID']['output'];
  pass: Pass;
  paymentTransaction?: Maybe<PaymentTransaction>;
  uid: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Data required to process a pass purchase transaction. */
export type PassPurchaseTransactionDataInput = {
  /** The code of the coupon applied to the transaction, if any. */
  couponCode?: InputMaybe<Scalars['String']['input']>;
  /** The name of the customer making the transaction. */
  customerName: Scalars['String']['input'];
  /** Indicates if the transaction was created by a manual booking. */
  manual?: InputMaybe<Scalars['Boolean']['input']>;
  /** The global ID of the pass being purchased. */
  passGid: Scalars['ID']['input'];
  /** The phone number of the customer. */
  phoneNumber: Scalars['String']['input'];
  /** The slug of the store where the purchase is made. */
  storeSlug?: InputMaybe<Scalars['String']['input']>;
};

/** A record of a payment transaction. */
export type PaymentTransaction = {
  __typename?: 'PaymentTransaction';
  amount: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  data?: Maybe<PaymentTransactionData>;
  datatransId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  paymentMethod: Scalars['String']['output'];
  purchaseType: PurchaseType;
  reference: Scalars['String']['output'];
  status: PaymentTransactionStatus;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Data associated with a payment transaction. */
export type PaymentTransactionData = {
  __typename?: 'PaymentTransactionData';
  couponCode?: Maybe<Scalars['String']['output']>;
  customerName: Scalars['String']['output'];
  kidCustomer: Scalars['Boolean']['output'];
  manual: Scalars['Boolean']['output'];
  passGid?: Maybe<Scalars['ID']['output']>;
  phoneNumber: Scalars['String']['output'];
  silentBooking?: Maybe<Scalars['Boolean']['output']>;
  storeSlug?: Maybe<Scalars['String']['output']>;
};

/** The status of a payment transaction. */
export enum PaymentTransactionStatus {
  Authenticated = 'AUTHENTICATED',
  Authorized = 'AUTHORIZED',
  /** Legacy */
  Cancel = 'CANCEL',
  Canceled = 'CANCELED',
  ChallengeOngoing = 'CHALLENGE_ONGOING',
  ChallengeRequired = 'CHALLENGE_REQUIRED',
  /** The default status */
  Created = 'CREATED',
  /** Legacy */
  Error = 'ERROR',
  Failed = 'FAILED',
  Initialized = 'INITIALIZED',
  Settled = 'SETTLED',
  Success = 'SUCCESS',
  Transmitted = 'TRANSMITTED',
  Uncomplete = 'UNCOMPLETE'
}

/** A pre-booking made by a customer for a service at a store. */
export type PreBooking = {
  __typename?: 'PreBooking';
  bookTime: Scalars['ISO8601DateTime']['output'];
  coupon?: Maybe<Coupon>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  customer: Customer;
  id: Scalars['ID']['output'];
  service: Service;
  state: PreBookingState;
  store: Store;
  uid: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Broadcast message for pre-booking events. */
export type PreBookingBroadcast = {
  __typename?: 'PreBookingBroadcast';
  operation: BroadcastOperation;
  preBooking: PreBooking;
};

/** The connection type for PreBooking. */
export type PreBookingConnection = {
  __typename?: 'PreBookingConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PreBookingEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PreBooking>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PreBookingEdge = {
  __typename?: 'PreBookingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PreBooking>;
};

/** The state of a pre-booking. */
export enum PreBookingState {
  /** Cancelled */
  Cancelled = 'CANCELLED',
  /** Converted */
  Converted = 'CONVERTED',
  /** Scheduled */
  Scheduled = 'SCHEDULED'
}

/** Data required to create a pre-booking payment transaction. */
export type PreBookingTransactionDataInput = {
  /** The time the pre-booking is scheduled for. */
  bookTime: Scalars['ISO8601DateTime']['input'];
  /** The code of the coupon applied to the transaction, if any. */
  couponCode?: InputMaybe<Scalars['String']['input']>;
  /** The name of the customer making the transaction. */
  customerName: Scalars['String']['input'];
  /** Indicates if the customer is a kid. */
  kidCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates if the transaction was created by a manual booking. */
  manual?: InputMaybe<Scalars['Boolean']['input']>;
  /** The phone number of the customer. */
  phoneNumber: Scalars['String']['input'];
  /** Indicates if the booking is silent. */
  silentBooking?: InputMaybe<Scalars['Boolean']['input']>;
  /** The slug of the store where the pre-booking is made. */
  storeSlug: Scalars['String']['input'];
};

/** A employee presence record */
export type Presence = {
  __typename?: 'Presence';
  duration: Scalars['Int']['output'];
  employeeId: Scalars['Int']['output'];
  endTime: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  originalPresenceId?: Maybe<Scalars['Int']['output']>;
  overrideReason?: Maybe<OverrideReason>;
  recurring: Scalars['Boolean']['output'];
  startTime: Scalars['ISO8601DateTime']['output'];
  storeId: Scalars['Int']['output'];
};

/** The connection type for Presence. */
export type PresenceConnection = {
  __typename?: 'PresenceConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PresenceEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Presence>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PresenceEdge = {
  __typename?: 'PresenceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Presence>;
};

/** The type of purchase associated with the transaction. */
export enum PurchaseType {
  /** Transaction for a booking */
  Booking = 'BOOKING',
  /** Transaction for a DRYCUT pass */
  Pass = 'PASS'
}

/** The query root of this schema. */
export type Query = {
  __typename?: 'Query';
  /** Get a booking based on its uid. */
  booking?: Maybe<Booking>;
  /** Get business hours for a store (GlobalID). */
  businessHours: StoreBusinessHours;
  /** Get API users (stylists) that are currently checked in at the current store. */
  checkedInApiUsers: Array<ApiUser>;
  /** Get checked in stylists for the authenticated store. */
  checkedInStylists: EmployeeConnection;
  /** Get a coupon by code. */
  coupon?: Maybe<Coupon>;
  /** Get a customer by code. */
  customer?: Maybe<Customer>;
  /** Get a pass by ID (GlobalID). */
  pass?: Maybe<Pass>;
  /** Get a pass purchase by uid. */
  passPurchase?: Maybe<PassPurchase>;
  /** Get active passes */
  passes: PassConnection;
  /** Get a payment transaction by ID (GlobalID). */
  paymentTransaction?: Maybe<PaymentTransaction>;
  /** Get a pre booking based on its uid. */
  preBooking?: Maybe<PreBooking>;
  /** Get pre-bookings in the future, not cancelled by store ID (GlobalID). */
  preBookings: PreBookingConnection;
  /** Get presences for a store */
  presences: PresenceConnection;
  /** Search customers by phone number. */
  searchCustomers: Array<Customer>;
  /** Get the service executions of the authenticated store to populate the queues. */
  serviceExecutions: ServiceExecutionConnection;
  /** Get a store by slug. */
  store?: Maybe<Store>;
  /** Get the pre bookings of the authenticated store for the current day. */
  storePreBookings: PreBookingConnection;
  /** Get active stores */
  stores: StoreConnection;
  /** Get active stylists. */
  stylists: EmployeeConnection;
};


/** The query root of this schema. */
export type QueryBookingArgs = {
  uid: Scalars['String']['input'];
};


/** The query root of this schema. */
export type QueryBusinessHoursArgs = {
  storeId: Scalars['ID']['input'];
};


/** The query root of this schema. */
export type QueryCheckedInStylistsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The query root of this schema. */
export type QueryCouponArgs = {
  code: Scalars['String']['input'];
};


/** The query root of this schema. */
export type QueryCustomerArgs = {
  code: Scalars['String']['input'];
};


/** The query root of this schema. */
export type QueryPassArgs = {
  passId: Scalars['ID']['input'];
};


/** The query root of this schema. */
export type QueryPassPurchaseArgs = {
  uid: Scalars['String']['input'];
};


/** The query root of this schema. */
export type QueryPassesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The query root of this schema. */
export type QueryPaymentTransactionArgs = {
  paymentTransactionId: Scalars['ID']['input'];
};


/** The query root of this schema. */
export type QueryPreBookingArgs = {
  uid: Scalars['String']['input'];
};


/** The query root of this schema. */
export type QueryPreBookingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  storeId: Scalars['ID']['input'];
};


/** The query root of this schema. */
export type QueryPresencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from: Scalars['ISO8601Date']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  storeId: Scalars['ID']['input'];
  to: Scalars['ISO8601Date']['input'];
};


/** The query root of this schema. */
export type QuerySearchCustomersArgs = {
  query: Scalars['String']['input'];
};


/** The query root of this schema. */
export type QueryServiceExecutionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The query root of this schema. */
export type QueryStoreArgs = {
  slug: Scalars['String']['input'];
};


/** The query root of this schema. */
export type QueryStorePreBookingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The query root of this schema. */
export type QueryStoresArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The query root of this schema. */
export type QueryStylistsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  onlyCheckedOut?: InputMaybe<Scalars['Boolean']['input']>;
  onlyScheduled?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated input type of QueueService */
export type QueueServiceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the service execution to be queued. */
  serviceExecutionId: Scalars['ID']['input'];
};

/** Autogenerated return type of QueueService. */
export type QueueServicePayload = {
  __typename?: 'QueueServicePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<RecordError>;
  serviceExecution?: Maybe<ServiceExecution>;
};

/** A record error */
export type RecordError = {
  __typename?: 'RecordError';
  /** A description of the error */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

/** A review left by a customer for a booking. */
export type Review = {
  __typename?: 'Review';
  booking: Booking;
  customer: Customer;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  score: Scalars['Int']['output'];
  store: Store;
};

/** Attributes for creating a review. */
export type ReviewInput = {
  /** Optional text description of the review. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Numerical score of the review. */
  score: Scalars['Int']['input'];
};

/** A service offered by the store. */
export type Service = {
  __typename?: 'Service';
  id: Scalars['ID']['output'];
  kidsPrice?: Maybe<Scalars['Int']['output']>;
  price: Scalars['Int']['output'];
};

/** An execution of a service for a booking. */
export type ServiceExecution = {
  __typename?: 'ServiceExecution';
  booking: Booking;
  calledAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  customer?: Maybe<Customer>;
  employee?: Maybe<Employee>;
  endedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  held: Scalars['Boolean']['output'];
  heldAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  noPauseAfterEnded: Scalars['Boolean']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  projectedBookTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  projectedStartTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  projectedWaitingTime: Scalars['Int']['output'];
  reminderSent: Scalars['Boolean']['output'];
  service: Service;
  startReminderAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  startedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  state: ServiceState;
  store: Store;
  stylist?: Maybe<Employee>;
};

/** Broadcast for service execution events. */
export type ServiceExecutionBroadcast = {
  __typename?: 'ServiceExecutionBroadcast';
  operation: BroadcastOperation;
  serviceExecution: ServiceExecution;
};

/** The connection type for ServiceExecution. */
export type ServiceExecutionConnection = {
  __typename?: 'ServiceExecutionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ServiceExecutionEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ServiceExecution>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ServiceExecutionEdge = {
  __typename?: 'ServiceExecutionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ServiceExecution>;
};

/** The state of a service execution. */
export enum ServiceState {
  /** Service is called */
  Called = 'CALLED',
  /** Service is canceled */
  Canceled = 'CANCELED',
  /** Service has ended */
  Ended = 'ENDED',
  /** Service is on hold */
  OnHold = 'ON_HOLD',
  /** Service is queued */
  Queued = 'QUEUED',
  /** Service has started */
  Started = 'STARTED'
}

/** Autogenerated input type of SnoozeReminder */
export type SnoozeReminderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the service execution to snooze. */
  serviceExecutionId: Scalars['ID']['input'];
};

/** Autogenerated return type of SnoozeReminder. */
export type SnoozeReminderPayload = {
  __typename?: 'SnoozeReminderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<RecordError>;
  serviceExecution?: Maybe<ServiceExecution>;
};

/** Autogenerated input type of StartBreak */
export type StartBreakInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Duration of the break in minutes. */
  duration: Scalars['Int']['input'];
  internal?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID of the stylist starting the break. */
  stylistId: Scalars['ID']['input'];
};

/** Autogenerated return type of StartBreak. */
export type StartBreakPayload = {
  __typename?: 'StartBreakPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<RecordError>;
  stylist?: Maybe<Employee>;
};

/** Autogenerated input type of StartService */
export type StartServiceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the service execution to start. */
  serviceExecutionId: Scalars['ID']['input'];
};

/** Autogenerated return type of StartService. */
export type StartServicePayload = {
  __typename?: 'StartServicePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<RecordError>;
  serviceExecution?: Maybe<ServiceExecution>;
  stylist?: Maybe<Employee>;
};

/** A salon. */
export type Store = {
  __typename?: 'Store';
  active: Scalars['Boolean']['output'];
  bookingsCount: Scalars['Int']['output'];
  businessHours: StoreBusinessHours;
  checkedInStylists: Array<Employee>;
  checkoutType: CheckoutEnum;
  createdAt: Scalars['ISO8601DateTime']['output'];
  googleReviewUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  location: StoreLocation;
  name: Scalars['String']['output'];
  nextAvailableTime?: Maybe<Scalars['ISO8601DateTime']['output']>;
  preBookingTax: Scalars['Int']['output'];
  promotionBadge: Attachment;
  promotionBadgeActive: Scalars['Boolean']['output'];
  promotionBadgeInfoscreen: Scalars['Boolean']['output'];
  service: Service;
  slug: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  waitingTime: Scalars['Int']['output'];
};

/** Business hours for a specific day of the week for a store. */
export type StoreBusinessDay = {
  __typename?: 'StoreBusinessDay';
  closed: Scalars['Boolean']['output'];
  endTime: Scalars['String']['output'];
  startTime: Scalars['String']['output'];
};

/** Business hours for a store. */
export type StoreBusinessHours = {
  __typename?: 'StoreBusinessHours';
  friday: StoreBusinessDay;
  /** Holidays for the store (only future holidays are returned) */
  holidays: Array<StoreHoliday>;
  monday: StoreBusinessDay;
  saturday: StoreBusinessDay;
  sunday: StoreBusinessDay;
  thursday: StoreBusinessDay;
  tuesday: StoreBusinessDay;
  wednesday: StoreBusinessDay;
};

/** The connection type for Store. */
export type StoreConnection = {
  __typename?: 'StoreConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<StoreEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Store>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type StoreEdge = {
  __typename?: 'StoreEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Store>;
};

/** A holiday for a store. */
export type StoreHoliday = {
  __typename?: 'StoreHoliday';
  closed: Scalars['Boolean']['output'];
  date: Scalars['ISO8601Date']['output'];
  endTime: Scalars['String']['output'];
  startTime: Scalars['String']['output'];
};

/** A physical location of a store. */
export type StoreLocation = {
  __typename?: 'StoreLocation';
  city: Scalars['String']['output'];
  mapUrl?: Maybe<Scalars['String']['output']>;
  street: Scalars['String']['output'];
  zipCode: Scalars['String']['output'];
};

/** Autogenerated input type of StoreSignIn */
export type StoreSignInInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The password for the store. */
  password: Scalars['String']['input'];
  /** The slug identifier for the store. */
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of StoreSignIn. */
export type StoreSignInPayload = {
  __typename?: 'StoreSignInPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<RecordError>;
  store?: Maybe<Store>;
  token?: Maybe<Scalars['String']['output']>;
};

/** Broadcast message for stylist-related events. */
export type StylistBroadcast = {
  __typename?: 'StylistBroadcast';
  operation: BroadcastOperation;
  stylist: Employee;
};

/** The current state of a stylist in the salon. */
export enum StylistState {
  /** On a break */
  Break = 'BREAK',
  /** Not in the salon */
  CheckedOut = 'CHECKED_OUT',
  /** Not working but available */
  Idle = 'IDLE',
  /** Waiting for a customer */
  WaitingCustomer = 'WAITING_CUSTOMER',
  /** Working on a haircut */
  Working = 'WORKING'
}

/** The subscription root of this schema */
export type Subscription = {
  __typename?: 'Subscription';
  /** Subscribe to changes in a booking. */
  bookingUpdate: Booking;
  /** Subscribe to changes in the pre bookings of a store. */
  preBookingUpdate: PreBookingBroadcast;
  /** Subscribe to changes in the service executions of a store. */
  serviceExecutionUpdate: ServiceExecutionBroadcast;
  /** Subscribe to changes in the store. */
  storeUpdate: Store;
  /** Subscribe to changes on employee checked in a store. */
  stylistUpdate: StylistBroadcast;
};


/** The subscription root of this schema */
export type SubscriptionBookingUpdateArgs = {
  uid: Scalars['ID']['input'];
};


/** The subscription root of this schema */
export type SubscriptionPreBookingUpdateArgs = {
  slug: Scalars['String']['input'];
};


/** The subscription root of this schema */
export type SubscriptionServiceExecutionUpdateArgs = {
  slug: Scalars['String']['input'];
};


/** The subscription root of this schema */
export type SubscriptionStoreUpdateArgs = {
  slug: Scalars['String']['input'];
};


/** The subscription root of this schema */
export type SubscriptionStylistUpdateArgs = {
  slug: Scalars['String']['input'];
};

/** Autogenerated input type of UpdatePreferences */
export type UpdatePreferencesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The unique code identifying the customer. */
  code: Scalars['String']['input'];
  /** The preferences data to update. */
  data: CustomerPreferencesInput;
};

/** Autogenerated return type of UpdatePreferences. */
export type UpdatePreferencesPayload = {
  __typename?: 'UpdatePreferencesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  customer?: Maybe<Customer>;
  errors: Array<RecordError>;
};

/** Autogenerated input type of UpdateSettings */
export type UpdateSettingsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The unique code identifying the customer. */
  code: Scalars['String']['input'];
  /** The new settings data for the customer. */
  data: CustomerSettingsInput;
};

/** Autogenerated return type of UpdateSettings. */
export type UpdateSettingsPayload = {
  __typename?: 'UpdateSettingsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  customer?: Maybe<Customer>;
  errors: Array<RecordError>;
};

/** Autogenerated input type of ValidateCoupon */
export type ValidateCouponInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The coupon code to validate. */
  code: Scalars['String']['input'];
  /** The phone number of the customer. */
  phoneNumber: Scalars['String']['input'];
};

/** Autogenerated return type of ValidateCoupon. */
export type ValidateCouponPayload = {
  __typename?: 'ValidateCouponPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  coupon?: Maybe<Coupon>;
  errors: Array<RecordError>;
};

/** Autogenerated input type of ValidatePhoneCustomer */
export type ValidatePhoneCustomerInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The phone number to validate. */
  phoneNumber: Scalars['String']['input'];
};

/** Autogenerated return type of ValidatePhoneCustomer. */
export type ValidatePhoneCustomerPayload = {
  __typename?: 'ValidatePhoneCustomerPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  customer?: Maybe<Customer>;
  errors: Array<RecordError>;
};

/** Autogenerated input type of ValidatePhoneNumber */
export type ValidatePhoneNumberInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The phone number to validate. */
  phoneNumber: Scalars['String']['input'];
};

/** Autogenerated return type of ValidatePhoneNumber. */
export type ValidatePhoneNumberPayload = {
  __typename?: 'ValidatePhoneNumberPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<RecordError>;
  valid: Scalars['Boolean']['output'];
};

/** Autogenerated input type of VerifyStylistCredentials */
export type VerifyStylistCredentialsInput = {
  /** API User ID to verify */
  apiUserId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Password to verify */
  password: Scalars['String']['input'];
};

/** Autogenerated return type of VerifyStylistCredentials. */
export type VerifyStylistCredentialsPayload = {
  __typename?: 'VerifyStylistCredentialsPayload';
  apiUser?: Maybe<ApiUser>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<RecordError>;
  success: Scalars['Boolean']['output'];
};
